import type { ComponentType } from 'react'
import type { ChatPanelProps } from '../components/ChatPanel'

// The chat panel brings the markdown renderer with it, so its code loads the
// first time the panel opens (or the pointer reaches its button), not with
// every page. One import is shared, so a hover's head start isn't repeated; a
// failed one is forgotten so the next open tries again.
let chatPanelModule: Promise<{ default: ComponentType<ChatPanelProps> }> | null = null

export function loadChatPanel() {
  chatPanelModule ??= import('../components/ChatPanel').catch((error: unknown) => {
    chatPanelModule = null
    throw error
  })
  return chatPanelModule
}

export const CHAT_PANEL_MIN_WIDTH_PX = 360
export const CHAT_PANEL_MAX_WIDTH_PX = 640
